import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CDropdown from '@/components/CDropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlaceholderSelector',
  props: {
    providerPlaceholders: null,
    templateProductPlaceholders: null
  },
  emits: ['placeholder-selected'],
  setup(__props: any, { emit }) {

const props = __props as {
    providerPlaceholders: string[];
    templateProductPlaceholders: {
        epsId: number;
        epsName: string;
        providerPlaceholderId: string;
    }[];
};





const providerPlaceholders = computed(() => {
    return props.providerPlaceholders.map((placeholder) => ({
        value: placeholder,
        text: placeholder
    }));
});
const placeholderSelected = (value: unknown, idx: number) => {
    emit('placeholder-selected', value, idx);
};

return { __sfc: true,emit, props, providerPlaceholders, placeholderSelected, CDropdown }
}

})